/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment } from 'react';
import './styles.less';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import AddButton from '../../../../components/images/add-button.svg';
import { CustomRequiredComponent } from '../../../../semantic-ui/components/custom-required';
import { FormSelectField } from '../../../../semantic-ui/components/form-select-field';
import { FormInputField } from '../../../../semantic-ui/components/form-input-field';
import { normalizeInteger } from '../../../../utils/normalizeInteger';
import { PieceIcon } from '../../../../components/text-icon';

export const IcepacksComponent = ({ fields, icepacksOptions, isIcepacksLoading }) => {
	if (fields.length === 0) {
		return [
			<Fragment key="icepacks.icepack">
				<Grid.Row className="icepacks-component__row">
					<Grid.Column width={14} className="icepacks-component__column">
						<div className="icepacks-component__button-row">
							<div className="icepacks-component__button-row-text">Добавить хладоэлемент</div>
							<img src={AddButton} alt="add-button" onClick={() => fields.push({})} />
						</div>
					</Grid.Column>
				</Grid.Row>
			</Fragment>,
		];
	}

	return fields.map((name, index) => {
		const isDeleteButtonShown = index === fields.length - 1;

		const isLastField = index === fields.length - 1;

		return (
			<Fragment key={`${name}.icepack`}>
				<Grid.Row className="icepacks-component__row">
					<Grid.Column className="icepacks-component__header">
						<Grid.Column className="icepacks-component__text">Хладоэлемент #{index + 1}</Grid.Column>
						{isDeleteButtonShown && (
							<div
								className="icepacks-component__column_close"
								onClick={() => {
									fields.remove(index);
								}}
							/>
						)}
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="icepacks-component__row">
					<Grid.Column width={6} className="icepacks-component__column">
						Хладоэлемент с наполнителем
						<CustomRequiredComponent />
					</Grid.Column>
					<Grid.Column width={8} className="icepacks-component__column">
						<Field
							name={`${name}.icepack_filled_id`}
							type="text"
							component={FormSelectField}
							autoComplete="off"
							options={icepacksOptions}
							search
							loading={isIcepacksLoading}
							disabled={isIcepacksLoading}
							noResultsMessage="Хладоэлементы с наполнителем не найдены"
							placeholder="Выберите хладоэлемент с наполнителем"
							isWithoutSelectOnBlur
							dropdownClassName="static"
						/>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="icepacks-component__row">
					<Grid.Column width={6} className="icepacks-component__column">
						Кол-во
						<CustomRequiredComponent />
					</Grid.Column>
					<Grid.Column width={8} className="icepacks-component__column">
						<Field
							name={`${name}.count`}
							type="text"
							normalize={normalizeInteger}
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите кол-во хладоэлементов"
							icon={PieceIcon}
						/>
					</Grid.Column>
				</Grid.Row>

				{isLastField && (
					<Grid.Row className="icepacks-component__row">
						<Grid.Column width={14} className="icepacks-component__column">
							<div className="icepacks-component__button-row">
								<div className="icepacks-component__button-row-text">Добавить хладоэлемент</div>
								<img src={AddButton} alt="add-button" onClick={() => fields.push({})} />
							</div>
						</Grid.Column>
					</Grid.Row>
				)}
			</Fragment>
		);
	});
};

IcepacksComponent.propTypes = {
	fields: PropTypes.object.isRequired,
	icepacksOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksLoading: PropTypes.bool.isRequired,
};
